(function (angular) {
    'use strict';

    angular.module('inboundRules')
        /**
         *
         */
        .controller('createMessageModalCtrl',
            ['$scope', '$uibModalInstance', 'settings', 'inboundRule',
                function ($scope, $uibModalInstance, settings, inboundRule) {

                    $scope.settings = angular.copy(settings);
                    $scope.inboundRule = angular.copy(inboundRule);

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $scope.close = function () {
                        $uibModalInstance.close($scope.inboundRule);
                    };



                }]);




})(window.angular);
